import t from "react";
import e from "prop-types";
import { Field as u } from "./index255.mjs";
import "./index10.mjs";
import { CountryCodePhone as P } from "./index258.mjs";
import { COUNTRY_CODE_PHONE_FIELD_STATES as c } from "./index259.mjs";
import { ICON_LIST as T } from "./index158.mjs";
const m = (p) => {
  const {
    autocomplete: o,
    classes: C,
    disabled: r,
    hint: i,
    // eslint-disable-next-line react/prop-types
    countryCodes: f,
    id: b,
    name: g,
    onChange: l,
    placeholder: s,
    countryCodePlaceholder: y,
    readonly: h,
    required: n,
    state: a,
    title: q,
    value: d,
    style: R,
    // eslint-disable-next-line react/prop-types
    hotelCountryCode: E,
    additionalClasses: O
  } = p;
  return /* @__PURE__ */ t.createElement(
    u,
    {
      autocomplete: o,
      classes: C,
      disabled: r,
      id: b,
      name: g,
      onChange: l,
      placeholder: s,
      readonly: h,
      required: n,
      state: a,
      title: q,
      value: d,
      style: R
    },
    /* @__PURE__ */ t.createElement(
      P,
      {
        hotelCountryCode: E,
        countryCodes: f,
        value: d,
        onChange: l,
        required: n,
        disabled: r,
        state: a,
        classes: O,
        autocomplete: o,
        placeholder: s,
        countryCodePlaceholder: y
      }
    ),
    i ? /* @__PURE__ */ t.createElement(u.Hint, null, i) : null
  );
};
m.propTypes = {
  autocomplete: e.bool,
  classes: e.string,
  disabled: e.bool.isRequired,
  hint: e.string,
  icon: e.oneOf(Object.values(T)),
  id: e.string.isRequired,
  label: e.string.isRequired,
  name: e.string.isRequired,
  onChange: e.func.isRequired,
  placeholder: e.string,
  countryCodePlaceholder: e.string,
  readonly: e.bool,
  required: e.bool.isRequired,
  state: e.oneOf(Object.values(c)).isRequired,
  title: e.string,
  tooltip: e.string,
  value: e.object,
  style: e.object,
  additionalClasses: e.string
};
m.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  required: !1,
  // eslint-disable-next-line react/default-props-match-prop-types
  state: c.DEFAULT,
  // eslint-disable-next-line react/default-props-match-prop-types
  disabled: !1
};
export {
  m as CountryCodePhoneField,
  m as default
};
